<ng-container *ngIf="initialized && dto">

    <div class="min-h-screen flex surface-ground mt-5">

        <div class="col-12 p-0"
             *ngIf="activeNavigationItem"
             [ngClass]="activeNavigationItem?.action == 'Testen' ?
                      'lg:col-5' : 'lg:col-3'">

            <div class="surface-border border-round shadow-1 flex-auto h-full surface-section flex flex-column overflow-hidden">

                @if (activeNavigationItem?.action === 'Editor') {
                    <!-- Sub-tabs for left panel content -->
                    <p-tabs [value]="activeLeftPanelTabValue" (valueChange)="onLeftPanelTabChange($event)" styleClass="te-left-panel-tabs">
                        <p-tablist>
                            @for (tab of leftPanelTabs; track tab.action; let i = $index) {
                                <p-tab [value]="'' + i">
                                    <i [class]="tab.icon" class="mr-1"></i>
                                    {{ tab.label }}
                                </p-tab>
                            }
                        </p-tablist>
                    </p-tabs>

                    <!-- Sub-tab content -->
                    <div class="flex-1 overflow-auto p-3">
                        @switch (activeLeftPanelTab?.action) {
                            @case ('Variablen') {
                                <mvs-te-variables
                                        *ngIf="dto.id"
                                        [variableProviderService]="crudService"
                                        alias="te.TeTemplateVariable"
                                        attributeName="template"
                                        [contentProviderId]="dto.id"
                                        (onVariableRenamed)="handleVariableRenamed($event)"
                                        (onTableInsert)="handleTableInsert($event)"
                                ></mvs-te-variables>
                            }
                            @case ('Artefakte') {
                                <mvs-embedded-artefacts
                                        *ngIf="dto.id"
                                        [templateId]="dto.id"
                                ></mvs-embedded-artefacts>
                            }
                            @case ('Basisdaten') {
                                <mvs-widget *ngIf="widgetBasicData" [widgetData]="widgetBasicData"></mvs-widget>
                            }
                        }
                    </div>
                }

                @if (activeNavigationItem?.action === 'Testen') {
                    <div class="p-3 h-full overflow-auto">
                        <mvs-te-test-case
                                [templateId]="dto.id"
                                [initialTestCaseId]="selectedTestCase?.dto?.id"
                                (onSelectTestCase)="handleSelectTestCase($event)"
                        ></mvs-te-test-case>
                    </div>
                }

            </div>
        </div>

        <div class="min-h-screen p-0 col-12"
             [ngClass]="activeNavigationItem.action == 'Testen' ?
                      'lg:col-7' : !activeNavigationItem ? 'lg:col-12' : 'lg:col-9'">

            <div class="px-3 h-full" [ngClass]="activeNavigationItem?.action == 'Testen' ? 'hidden' : 'block'">
                <div class="surface-border surface-section flex-auto px-5 h-full shadow-1 border-round">
                    <mvs-te-editor
                            [variableProviderService]="crudService"
                            [contentProviderId]="dto.id"
                            [selectedTestCase]="selectedTestCase"
                            [content]="dto.content"
                            [editorTypeEnum]="dto.editorTypeEnum"
                            [artefactMap]="artefactMap"
                            [previewEnabled]="false"
                            [testPreviewHtml]="trustedGenerateResponseHtml"
                            [testPreviewPdf]="trustedGenerateResponsePdf"
                            [testPreviewBusy]="busy"
                            [testPreviewError]="occurredException"
                            [testPreviewErrorDetails]="occurredExceptionDetails"
                            (onSave)="handleEditorOnSave($event)"
                            (onGeneratePreview)="generateDocument()"
                            [contentType]="dto.contentTypeEnum"
                            alias="te.TeTemplateVariable"
                            attributeName="template"
                    ></mvs-te-editor>
                </div>
            </div>

            <div class="px-2" *ngIf="activeNavigationItem.action == 'Testen'">
                <mvs-te-test-case-setup></mvs-te-test-case-setup>
            </div>

        </div>
    </div>

</ng-container>
